import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
// import aprAtividade from '@/shared/http/repositories/business/aprAtividade'
import reportQmaRepository from '@/shared/http/repositories/business/qmaReportRepository'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'qmaReportFiltro',
  components: {AutocompleteZ},
  mixins: [ActionsForm, ExpenseMixin],
  props: ['report'],
  data () {
    return {
      form: {
        Apr: null,
        InicioDataSolicitacao: null,
        FimDataSolicitacao: null,
        ResponsavelId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        obraid: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        AtividadeId: null
      },
      dataAtividade: []
    }
  },
  mounted () {
    this.GetAtividade()
  },
  methods: {
    Search () {
      this.$emit('search', {
        Fluxo: this.report,
        numeroQma: this.form.Apr,
        ResponsavelId: this.form.ResponsavelId.value,
        TemplateItemAvaliacaoId: this.form.AtividadeId,
        DataInicio: this.form.InicioDataSolicitacao,
        DataFinal: this.form.FimDataSolicitacao,
        ObraId: this.form.obraid.value
      })
    },
    onClearSection () {
      this.$refs.obraRHTypeahead.clear()
      this.form.Apr = null
      this.form.InicioDataSolicitacao = null
      this.form.FimDataSolicitacao = null
      this.form.AtividadeId = null
      this.form.Apr = null
      this.ResponsavelId.code = null
      this.ResponsavelId.options = null
      this.ResponsavelId.required = null
      this.ResponsavelId.state = null
      this.ResponsavelId.value = null
    },
    GetAtividade () {
      loading.push()
      reportQmaRepository.GetQmaItem(this.report)
        .then((Response) => {
          loading.pop()
          this.dataAtividade = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaReport/components/qmaReportTable/components/qmaReportFiltro/qmaReportFiltro.js